import { isMobile } from './functions.js';

var $ = require("jquery");
require("jquery/package.json");

function menu_toggle() {
	const menu_toggle = document.querySelector('.menu-toggle');
	const html = document.querySelectorAll('html');
	const body = document.querySelectorAll('body');
	const mobileMenu = document.getElementById('primary-menu');
	const allElementsExceptMenu = document.querySelectorAll(
		'a:not(.site-header a)'
	);

	menu_toggle.addEventListener('click', (e) => {
		e.preventDefault();

		var value = menu_toggle.getAttribute('aria-expanded');
		var aria = value === 'true' ? 'false' : 'true';
		menu_toggle.setAttribute('aria-expanded', aria);

		var tabIndex = mobileMenu.getAttribute('tabindex');
		var ariaTab = tabIndex === '1' ? '0' : '1';
		mobileMenu.setAttribute('tabindex', ariaTab);

		body[0].classList.toggle('toggled');
		menu_toggle.classList.toggle('toggled');
		html[0].classList.toggle('lock-scroll');

		menu_toggle.blur();

		// Set tab indices for all elements except the menu based on menu state
		allElementsExceptMenu.forEach((element) => {
			element.tabIndex = aria === 'true' ? '-1' : '0';
		});

		// focus the first item in the menu when opening.
		if (aria === 'true') {
			setTimeout(() => {
				const firstFocusableElement = mobileMenu.querySelector(
					'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
				);
				if (firstFocusableElement) {
					// console.log(firstFocusableElement);
					firstFocusableElement.focus();
				}
			}, 100);
		}
	});
}
menu_toggle();

var lastScrollTop = 0;
var initialLoad = true;

function header_check() {
	const header = document.querySelector('[class*="b-site-header"]');
	const hero = document.querySelector("[class*='hero']");
	const fallbackSection = document.querySelector("section");

	// Use the hero if it exists, otherwise fall back to the first section
	const referenceElement = hero || fallbackSection;

	if (!referenceElement || !header) {
		// If no reference element or header exists, exit the function
		return;
	}

	var scroll = window.pageYOffset,
		content = referenceElement.clientHeight,
		position = referenceElement.clientHeight / 2,
		scrollTop = scroll;

	if (scrollTop >= content) {
		header.classList.add('active');
	} else {
		header.classList.remove('active');
	}

	if (scrollTop >= position) {
		header.classList.add('fixed');
	} else {
		header.classList.remove('fixed');
	}

	if (!initialLoad) {
		if (scrollTop > lastScrollTop) {
			// Scrolling down
			header.classList.add('down');
			header.classList.remove('up');
			header.style.transition = '300ms all';

			if (scrollTop >= position && scrollTop <= content) {
				header.style.transition = 'none';
			}
		} else if (scrollTop < lastScrollTop) {
			// Scrolling up
			header.classList.remove('down');
			header.classList.add('up');
			header.style.transition = '300ms all';

			if (scrollTop >= position) {
				header.style.transition = '300ms all';
			} else {
				header.style.transition = 'none';
			}
		}
	} else {
		header.classList.remove('down');
		header.classList.add('up', 'fixed');
	}

	if (initialLoad) {
		initialLoad = false;
	}
	lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
}

function initializeHeaderCheck() {
	// Run header_check function after layout has stabilized
	header_check();
	const observer = new ResizeObserver(() => {
		header_check();
		observer.disconnect(); // Stop observing after the initial check
	});
	observer.observe(document.body);
}

window.addEventListener('load', () => {
	setTimeout(initializeHeaderCheck, 1000); // Delay initialization if needed
});
document.addEventListener('scroll', header_check);


window.addEventListener('load', () => {
	setTimeout(initializeHeaderCheck, 1000); // Delay initialization if needed
});
document.addEventListener('scroll', header_check);


function menuDropdown() {

	// const menuItems = document.querySelectorAll('.menu-item-has-children');
	const menuItems = document.querySelectorAll('#primary-menu > .menu-item');
    const siteHeader = document.querySelector('[class*="b-site-header"]');
	const siteNavigation = document.querySelector('#site-navigation');
    const headerContainer = document.querySelector('.b-site-header__container');
    const menuChildren = document.querySelectorAll('.menu-item-has-children');

	if (isMobile()) {
		menuItems.forEach((el) => {
			const menuItemLink = el.querySelector('a');
			const dropdownMenu = el.querySelector('.dropdown-menu');
			const arrow = el.querySelector('.arrow');

			const menu_toggle = document.querySelector('.menu-toggle');
			const html = document.querySelectorAll('html');
			const body = document.querySelectorAll('body');

			// menuItemLink.addEventListener('click', (event) => {
			// 	console.log('click');
			// 	body[0].classList.toggle('toggled');
			// 	menu_toggle.classList.toggle('toggled');
			// 	html[0].classList.toggle('lock-scroll');
			// });

            if (dropdownMenu) {
                // Ensure that maxHeight is initially set to 'none' for accurate calculation of full height
                dropdownMenu.style.maxHeight = 'none';  // Ensures the dropdown is fully expanded for height calculation

                // Get the full scrollHeight of the dropdown
                const fullHeight = dropdownMenu.scrollHeight;

                // Reset maxHeight back to '0' to keep the dropdown hidden
                dropdownMenu.style.maxHeight = '0';

                // Set up smooth transition for opening/closing
                dropdownMenu.style.transition = 'max-height 0.3s ease, opacity 0.3s ease';

                arrow.addEventListener('click', (e) => {
                    e.preventDefault();

                    // Close other dropdowns
                    menuItems.forEach((item) => {
                        const otherDropdownMenu = item.querySelector('.dropdown-menu');
                        if (otherDropdownMenu && otherDropdownMenu !== dropdownMenu) {
                            otherDropdownMenu.style.maxHeight = '0';
                            otherDropdownMenu.setAttribute('aria-sub-expanded', 'false');
                            item.classList.remove('active');
                        }
                    });

                    // Toggle current dropdown state
                    const isExpanded = dropdownMenu.getAttribute('aria-sub-expanded') === 'true';

                    if (isExpanded) {
                        dropdownMenu.style.maxHeight = '0';  // Collapse dropdown
                        dropdownMenu.setAttribute('aria-sub-expanded', 'false');
                        el.classList.remove('active');
                    } else {
                        dropdownMenu.style.maxHeight = `${fullHeight}px`;  // Expand dropdown
                        dropdownMenu.setAttribute('aria-sub-expanded', 'true');
                        el.classList.add('active');

                        // Focus on the first link when the dropdown is opened
                        const firstLink = dropdownMenu.querySelector('a');
                        if (firstLink) {
                            firstLink.focus();
                        }
                    }
                });
            }

		});
	}

	if (!isMobile()) {
		// Function to remove 'active' class from all menu items
		function removeActiveClass() {
			menuItems.forEach((item) => {
				item.classList.remove('active');
			});
		}

        // Event listener for mouseenter and mouseleave on .b-site-header__container
        if (menuItems) {
            menuItems.forEach((el) => {
                el.addEventListener('mouseenter', () => {
                    siteHeader.classList.add('hover');
                });
            });
        }

        // Event listener for mouseenter and mouseleave on .b-site-header__container
        if (siteHeader) {
            siteHeader.addEventListener('mouseleave', () => {
                siteHeader.classList.remove('hover');
            });
        }

		// Event listener for mouseenter and mouseleave on menu items
		menuItems.forEach((item) => {
			const menuItemLink = item.querySelector('a');

			if (!isMobile()) {
				menuItemLink.addEventListener('mouseenter', () => {
					removeActiveClass();
					item.classList.add('active');
				});

				siteHeader.addEventListener('mouseleave', () => {
					item.classList.remove('active');
				});
			}

			menuItemLink.addEventListener('click', (event) => {
				// Check if the link is an anchor link
				const isAnchorLink =
					menuItemLink.getAttribute('href').charAt(0) === '#';
				// If it's an anchor link, prevent the default behavior
				if (isAnchorLink) {
					event.preventDefault();
				}
				// If it's not an anchor link, stop propagation to prevent closing the menu
				else {
					event.stopPropagation();
				}
			});
		});

		// Event listener for clicks outside of .menu-item-has-children
        document.addEventListener('click', (event) => {
            const menuItems = document.querySelectorAll('.menu-item-has-children');

            let isClickInsideMenuItem = false;

            menuItems.forEach((item) => {
                const rect = item.getBoundingClientRect();

                // Check if the click is within the bounds of the menu item, including gaps
                if (
                    event.clientX >= rect.left &&
                    event.clientX <= rect.right &&
                    event.clientY >= rect.top &&
                    event.clientY <= rect.bottom
                ) {
                    isClickInsideMenuItem = true;
                }
            });

            // // If the click is outside of the menu items, close the dropdown
            // if (!isClickInsideMenuItem) {
            //     removeActiveClass();

            //     if (isMobile()) {
            //         menuItems.forEach((item) => {
            //             const dropdownMenu = item.querySelector('.dropdown-menu');
            //             const otherDropdownMenu = item.querySelector('ul');

            //             otherDropdownMenu.style.maxHeight = '0px';
            //             otherDropdownMenu.setAttribute('aria-sub-expanded', 'false');
            //             item.classList.remove('active');
            //         });
            //     }
            // }
        });
	}
}
document.addEventListener('resize', menuDropdown);
// document.addEventListener('DOMContentLoaded', menuDropdown);
menuDropdown();

// Smooth scroll
// Handle anchor links
var anchorLinks = document.querySelectorAll('a[href*="#"]');
for (var i = 0; i < anchorLinks.length; i++) {
	var link = anchorLinks[i];
	if (
		link.getAttribute('href') !== '#' &&
		link.getAttribute('href') !== '#0'
	) {
		link.addEventListener('click', function (event) {
			// On-page links
			if (
				location.pathname.replace(/^\//, '') ==
					this.pathname.replace(/^\//, '') &&
				location.hostname == this.hostname
			) {
				// Figure out element to scroll to
				var target = document.querySelector(this.hash);
				target = target
					? target
					: document.querySelector(
							'[name=' + this.hash.slice(1) + ']'
						);
				// Does a scroll target exist?
				if (target) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					var scrollTop =
						target.getBoundingClientRect().top +
						window.pageYOffset -
						150;
					var duration = 1000;
					var easing = function (t) {
						return t * (2 - t);
					};
					var start = window.pageYOffset;
					var time = 0;
					var animateScroll = function () {
						time += 16;
						var elapsed = time / duration;
						elapsed = elapsed > 1 ? 1 : elapsed;
						var eased = easing(elapsed);
						var newScrollTop = start + (scrollTop - start) * eased;
						window.scrollTo(0, newScrollTop);
						if (time < duration) {
							window.requestAnimationFrame(animateScroll);
						} else {
							// Callback after animation
							// Must change focus!
							var $target = $(target);
							$target.focus();
							if ($target.is(':focus')) {
								// Checking if the target was focused
								return false;
							} else {
								$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
								$target.focus(); // Set focus again
							}
						}
					};
					animateScroll();
				}
			}
		});
	}
}

function siteHeaderState() {
    const siteHeader = document.querySelector('.b-site-header');
    const hero = document.querySelector('.b-hero__standard');

    // Check if the hero element has the class 'layout-2'
    if (hero && hero.classList.contains('layout-2')) {
        siteHeader.className += '--light';
    }
}
siteHeaderState();
